import {CompanyInfo, CompanyInfoFormValidationSchema} from '@/features/company-info/types'
import {ResponseType} from '@/types'

// Mock data for development
const mockCompanyInfo: CompanyInfo = {
    id: '1',
    name: 'HealthCare Solutions S.p.A.',
    taxId: '12345678901',
    fiscalCode: 'HCLSLT89S41F205X',
    legalAddress: 'Via Roma, 123',
    legalCity: 'Milano',
    legalProvince: 'MI',
    legalZip: '20100',
    hasDifferentOperationalAddress: true,
    operationalAddress: 'Via Torino, 456',
    operationalCity: 'Milano',
    operationalProvince: 'MI',
    operationalZip: '20123',
    phone: '+39 02 1234567',
    email: 'info@healthcaresolutions.it',
    pec: 'healthcare@pec.it',
    structureType: 'Hospital',
    regimeType: 'residential',
    modalityType: 'outpatient',
    nisCode: 'NIS123456',
    aslReference: '120201',
    bankName: 'Banca Intesa',
    bankBranch: 'Milano Centro',
    iban: 'IT12A0123456789000000123456',
    bic: 'BCITITMM'
}

// Get company info
export type HttpGetCompanyInfoOptions = {
    params?: {
        responseType: ResponseType
    }
}

export const getCompanyInfo = (options?: HttpGetCompanyInfoOptions) => {
    console.log('Mock get company info', options)
    // Mock API response
    return Promise.resolve({
        data: mockCompanyInfo
    })

    // Real API call (uncomment when backend is ready)
    // return axios.get<CompanyInfo>(COMPANY_INFO_API, {
    //     params: options?.params
    // })
}

// Update company info
export type HttpUpdateCompanyInfoOptions = {
    params?: {
        responseType: ResponseType
    }
    payload: CompanyInfoFormValidationSchema
}

export const updateCompanyInfo = (options: HttpUpdateCompanyInfoOptions) => {
    // Mock API response
    console.log('Mock update company info with payload:', options.payload)
    // Return success response with updated data
    return Promise.resolve({
        data: {
            ...mockCompanyInfo,
            ...options.payload
        }
    })

    // Real API call (uncomment when backend is ready)
    // return axios.patch<CompanyInfo>(COMPANY_INFO_API, options.payload, {
    //     params: options.params
    // })
}
